import { booleanAttribute, Component, input, output, ChangeDetectionStrategy } from '@angular/core';
import { IdGeneratorPipe } from '../../pipes/id-generator.pipe';

@Component({
    selector: 'lib-slide-toggle',
    templateUrl: './slide-toggle.component.html',
    styleUrls: ['./slide-toggle.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [IdGeneratorPipe]
})
export class SlideToggleComponent {
    label = input<string>();

    slideToggleId = input<string>();

    isReadOnly = input(false, { transform: booleanAttribute });

    checked = input(false, { transform: booleanAttribute });

    checkedChange = output<boolean>();

    onToggleChange(): void {
        const newValue = !this.checked();
        this.checkedChange.emit(newValue);
    }

    onKeyDown(event: KeyboardEvent): void {
        if (event.key === 'Enter') {
            this.onToggleChange();
        }
    }
}
